import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ToastService } from '../../shared/services/toast.service';

@Component({
  selector: 'app-linkedin-signup-wait',
  templateUrl: './linkedin-signup-wait.component.html',
  styleUrls: ['./linkedin-signup-wait.component.css']
})
export class LinkedinSignupWaitComponent implements OnInit {
  public linkedinLoginAccepted: Boolean = false;
  public userId;
  public socialNetworkType: string;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public authService: AuthService,
    public toastService: ToastService
  ) { }

  ngOnInit(
  ) {
    this.route.queryParams.subscribe(params => {
      for (let param in params) {
        if (params.hasOwnProperty(param)) {
        if (param === 'code') {
          this.linkedinLoginAccepted = true;
        }
        if (param === 'error') {
          this.linkedinLoginAccepted = false;
        }
      }
      }
      let tempArr = [];
       tempArr =  params['userId'].split('-');
       this.userId = tempArr[0];
       this.socialNetworkType = tempArr[1];

      if (this.socialNetworkType === 'LINKEDIN') {
        if (this.userId) {
          if (this.linkedinLoginAccepted) {
            this.authService.linkedinAccessToken(params['state'], this.userId, params['code'] ).subscribe(response => {
              this.toastService.success();
              // reroute to login page
              this.router.navigate(['login']);
            }, error => {
              this.router.navigate(['sign-up', this.userId]);
              this.toastService.error('Sign up with linkedin unsuccessful');
            });
          } else {
            this.router.navigate(['sign-up', this.userId]);
            this.toastService.error('Sign up unsuccessful');
          }
      } else {
        this.authService.linkedinAccessToken(params['state'], '', params['code'] ).subscribe(data => {
          if (data['isLogin'] === true) {
            this.authService.linkedinLogin(data['user']);
          } else {
            this.router.navigate(['/login']);
            this.toastService.error('Login unsuccessful');
          }
        }, error => {
          this.router.navigate(['/login']);
          this.toastService.error('Login unsuccessful');
        });
      }
  } else if (this.socialNetworkType === 'LINE') {
    if (this.userId) {
      if (this.linkedinLoginAccepted) {
        this.authService.lineAccessToken(params['state'], this.userId, params['code'] ).subscribe(response => {
          this.toastService.success();
          this.router.navigate(['sign-up', this.userId], {
            queryParams: {
              lineId: response['userId']
            }
        });
        }, error => {
          this.router.navigate(['sign-up', this.userId]);
          this.toastService.error('Sign up with line unsuccessful');
        });
      } else {
        this.router.navigate(['sign-up', this.userId]);
        this.toastService.error('Sign up unsuccessful');
      }
  } else {
    this.authService.lineAccessToken(params['state'], '', params['code'] ).subscribe(data => {
      if (data['isLogin'] === true) {
        this.authService.linkedinLogin(data['user']);
      } else {
        this.router.navigate(['/login']);
        this.toastService.error('Login unsuccessful');
      }
    }, error => {
      this.router.navigate(['/login']);
      this.toastService.error('Login unsuccessful');
    });
  }
  }
    });
  }

}
